// Lưu file về máy — thống nhất cho cả WEB và APP NATIVE (Capacitor).
// WebView Android KHÔNG tự lưu file khi bấm link download / blob như trình duyệt,
// nên trên native phải ghi file rồi mở "share sheet" để người dùng Lưu vào Files / gửi Zalo...
import { Capacitor } from '@capacitor/core';

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(String(r.result).split(',')[1] || '');
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

function safeName(name) {
  return (name || 'file').replace(/[/\\?%*:|"<>]+/g, '_').slice(0, 120);
}

// saveFile({ blob }) — lưu 1 Blob (vd CSV/Excel tạo tại client)
// saveFile({ url, filename }) — tải từ URL (vd file đính kèm chat) rồi lưu
export async function saveFile({ blob, url, filename }) {
  const name = safeName(filename);

  // WEB: giữ NGUYÊN hành vi cũ (link download / mở tab mới).
  if (!Capacitor?.isNativePlatform?.()) {
    const href = url || URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = name;
    if (url) { a.target = '_blank'; a.rel = 'noreferrer'; }
    document.body.appendChild(a);
    a.click();
    a.remove();
    if (!url) setTimeout(() => URL.revokeObjectURL(href), 2000);
    return;
  }

  // NATIVE: ghi file vào Cache rồi mở share sheet.
  const { Filesystem, Directory } = await import('@capacitor/filesystem');
  const { Share } = await import('@capacitor/share');
  let b = blob;
  if (!b && url) {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error('Tải file lỗi HTTP ' + res.status);
    b = await res.blob();
  }
  if (!b) throw new Error('Không có dữ liệu file');
  const base64 = await blobToBase64(b);
  const written = await Filesystem.writeFile({ path: name, data: base64, directory: Directory.Cache });
  try {
    await Share.share({ title: name, url: written.uri });
  } catch (e) {
    // Người dùng bấm hủy share -> bỏ qua (file đã ghi ở Cache).
  }
}

// Dùng cho thẻ <a> đính kèm: CHỈ chặn trên native; web để <a download> chạy như cũ.
export function onAttachmentClick(url, filename) {
  return (e) => {
    if (!Capacitor?.isNativePlatform?.()) return; // web: không đụng vào
    e.preventDefault();
    saveFile({ url, filename }).catch((err) => console.error('[download] lỗi:', err?.message || err));
  };
}
